<template>
    <applications-find
        v-slot="{
            has_loaded,
            is_loading,
            data: application,
            error,
            find
        }"
        :params="{
            application: this.$route.params.application
        }"
        :include="[
            'listing(include:property(include:address))'
        ]"
        :preloaded="preloaded('application')"
        :find-on-created="!preloaded('application')"
        @success="onSuccess"
    >
        <div>
            <template v-if="!has_loaded">
                <base-loading
                    :retry="find"
                    :error="error"
                    class="py-6"
                />

                <error-modal
                    v-if="error && $error.is(error, { exclude: [400, 422] })"
                    :error="error"
                />
            </template>

            <template v-else>
                <div class="px-4 py-6 border-b sm:px-6">
                    <div class="flex flex-col-reverse md:flex-row">
                        <div class="flex-grow md:pr-6">
                            <h1 class="mb-3 text-lg font-normal text-grey-darkest">
                                Welcome home!
                            </h1>

                            <p class="mb-3 text-grey-darker">
                                This rental application will be <strong>sent directly</strong> to the agent or
                                landlord of <strong>{{ application.listing.property.address.name }}</strong>.
                            </p>

                            <p>
                                <a
                                    href="https://help.rentora.co.uk/article/39-how-can-i-tell-if-a-listing-is-legitimate"
                                    class="inline-flex items-center text-blue"
                                    target="_blank"
                                    rel="noopener"
                                >
                                    How can I tell if a listing is legitimate?

                                    <base-svg
                                        name="icon-external-window"
                                        class="w-4 h-4 ml-1 fill-primary-blue fill-secondary-blue"
                                    />
                                </a>
                            </p>
                        </div>
                        <div class="flex-none mb-6 text-center md:mb-0 md:mt-3">
                            <div class="w-24 mx-auto">
                                <base-svg
                                    slot="image"
                                    name="illustration-home"
                                    class="w-full"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="px-4 py-6 border-b sm:px-6">
                    <grid-layout>
                        <grid-layout-item class="mb-3 sm:w-1/2 sm:mb-0">
                            <div class="text-xs tracking-wide uppercase text-grey-darker">Property</div>
                            <div class="text-sm text-grey-darkest">
                                <base-address :address="application.listing.property.address" />
                            </div>
                        </grid-layout-item>

                        <grid-layout-item class="sm:w-1/2">
                            <div class="text-xs tracking-wide uppercase text-grey-darker">Rent</div>
                            <div class="mb-3 text-sm text-grey-darkest">
                                {{ application.listing.rent_amount | money(0) }}
                            </div>

                            <div class="text-xs tracking-wide uppercase text-grey-darker">Deposit</div>
                            <div class="mb-3 text-sm text-grey-darkest">
                                {{ application.listing.deposit_amount | money(0) }}
                            </div>
                        </grid-layout-item>
                    </grid-layout>
                </div>

                <div class="px-4 py-3 text-right bg-grey-bg sm:px-6">
                    <router-link
                        :to="{
                            name: 'applications.users.create'
                        }"
                        class="w-full btn btn-blue md:w-auto"
                    >
                        Continue
                    </router-link>
                </div>
            </template>
        </div>
    </applications-find>
</template>

<script>
    import _ from 'lodash'
    import local from '../../../store/local'
    import HeadMixin from '../../../mixins/head'
    import PreloadedMixin from '../../../mixins/preloaded'
    import ApplicationsFind from '../../../components/applications-find'

    export default {
        mixins: [
            HeadMixin,
            PreloadedMixin
        ],
        components: {
            ApplicationsFind
        },
        data () {
            return {
                store: {
                    application: _.get(this.preloaded('application'), 'data')
                }
            }
        },
        created () {
            const email = _.get(_.preload('applicant'), 'data.email')

            if (email) local.set('guest-email', email)
        },
        methods: {
            onSuccess ({ data: application }) {
                if (!this.$isSsr) {
                    this.store.application = application
                }
            },
            head () {
                return {
                    title: [
                        'Welcome',
                        `${this.store.application.listing.property.address.name} Application`
                    ]
                }
            }
        }
    }
</script>
